import { render, staticRenderFns } from "./newLogbook.vue?vue&type=template&id=0912b924&scoped=true"
import script from "./newLogbook.vue?vue&type=script&lang=js"
export * from "./newLogbook.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./newLogbook.vue?vue&type=style&index=1&id=0912b924&prod&lang=css"
import style2 from "./newLogbook.vue?vue&type=style&index=2&id=0912b924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0912b924",
  null
  
)

export default component.exports